import MuiAutocomplete from '@mui/material/Autocomplete';
import Box from '../Box/Box';
import TextField from '../TextField/TextField';
import type { AutocompleteProps } from './IAutocomplete';
import { styles } from './styles';

const Autocomplete = <
    T,
    Multiple extends boolean | undefined = false,
    DisableClearable extends boolean | undefined = false,
    FreeSolo extends boolean | undefined = false,
>({
    sx,
    label,
    placeholder,
    required,
    error,
    helperText,
    variant,
    startAdornment,
    ...rest
}: AutocompleteProps<T, Multiple, DisableClearable, FreeSolo>) => (
    <MuiAutocomplete
        sx={[styles.root, ...(Array.isArray(sx) ? sx : [sx])]}
        renderInput={(params) => (
            <TextField
                {...params}
                label={label}
                placeholder={placeholder}
                required={required}
                error={error}
                helperText={helperText}
                variant={variant}
                InputProps={
                    startAdornment
                        ? {
                            ...params.InputProps,
                            startAdornment: (
                                <>
                                    <Box
                                        component="span"
                                        sx={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            pr: 1,
                                            alignSelf: 'flex-end',
                                            mb: '9px',
                                        }}
                                    >
                                        {startAdornment}
                                    </Box>
                                    {params.InputProps?.startAdornment}
                                </>
                            ),
                        }
                        : params.InputProps
                }
            />
        )}
        {...rest}
    />
);

export default Autocomplete;
